<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-file-alt"></i> Configuração de Mensagens Automáticas </h3>
        <small>Configuração das mensagens automáticas.</small>
      </div>
    </div>
    <ModeloAdd v-if="showAdd" ref="ModeloAdd" v-on:Back="onBack" />
    <ModeloList v-else ref="ModeloList" v-on:New="onNew" v-on:Edit="onEdit" />
      </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ModeloAdd from './components/add/mensagensautomaticasadd'
import ModeloList from './components/list/mensagensautomaticaConfigList.vue'

export default {
  name: 'MensagensAutomaticas',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    ModeloAdd,
    ModeloList
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ModeloAdd.onAdd()
      })
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.ModeloAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/mensagensautomaticas/mensagensautomaticas.vue